import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../auth/token.service';
import { AuthService } from '../auth/auth.service';
import { catchError, map, of } from 'rxjs';
import { CurrentUserService } from '../auth/current-user.service';
import { PortalContextService } from '../auth/portal-context.service';

export const guestGuard: CanActivateFn = (_route, _state) => {
  const token = inject(TokenService).getAccessToken();
  const router = inject(Router);
  const auth = inject(AuthService);
  const currentUser = inject(CurrentUserService);
  const portal = inject(PortalContextService);

  if (!token) {
    return true;
  }

  return auth.ensureFreshSession().pipe(
    map((user) => {
      if (!user) return true;
      if (portal.isDedicatedHost && portal.userPortal(user) !== portal.portal) {
        auth.logout();
        return true;
      }
      if (user.mustChangePassword) return router.createUrlTree(['/change-password']);
      if (portal.isDedicatedHost) return router.createUrlTree([portal.dashboardRoute]);
      return router.createUrlTree([user.tenantId ? currentUser.businessLandingRoute() : '/admin/dashboard']);
    }),
    catchError(() => {
      auth.logout();
      return of(true);
    }),
  );
};
